"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProposalData = exports.getProposalsMetadata = exports.fetchProposalData = exports.fetchProposalsMetadata = void 0;
const queries_1 = require("../queries");
const subgraphs_1 = require("../../config/subgraphs");
function fetchProposalsMetadata(rangeBegin, rangeLength, descending) {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.CONFIG_MANAGER_SUBGRAPH_URL[this.getOffchain().network];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        const result = yield this.getOffchain().apolloFetcher(subgraph, query.proposalsMetaQuery(rangeBegin, rangeLength, descending));
        return result.data.proposals;
    });
}
exports.fetchProposalsMetadata = fetchProposalsMetadata;
function fetchProposalData(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const subgraph = subgraphs_1.CONFIG_MANAGER_SUBGRAPH_URL[this.getOffchain().network];
        const query = queries_1.QueryBuilderFactory.getQuery(subgraph);
        const result = yield this.getOffchain().apolloFetcher(subgraph, query.proposalQuery(id));
        return result.data.proposal;
    });
}
exports.fetchProposalData = fetchProposalData;
function getProposalsMetadata(rangeBegin, rangeLength, descending) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.proposalsMetadata ||
            this.metadataParameters.rangeBegin != rangeBegin ||
            this.metadataParameters.rangeLength != rangeLength ||
            this.metadataParameters.descending != descending) {
            this.proposalsMetadata = (() => __awaiter(this, void 0, void 0, function* () { return this.fetchProposalsMetadata(rangeBegin, rangeLength, descending); }))();
            this.metadataParameters = { rangeBegin, rangeLength, descending };
        }
        return this.proposalsMetadata;
    });
}
exports.getProposalsMetadata = getProposalsMetadata;
function getProposalData(id) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!this.proposalsData[id])
            this.proposalsData[id] = (() => __awaiter(this, void 0, void 0, function* () { return this.fetchProposalData(id); }))();
        return this.proposalsData[id];
    });
}
exports.getProposalData = getProposalData;
